import styled, { css } from 'styled-components';

export const KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const StripRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 12px;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

export const ChartGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const OutboxLegend = styled.ul(
  ({ theme: { palette } }) => css`
    list-style: none;
    margin: 0;
    padding: 8px 0 0;
    display: flex;
    flex-direction: column;
    gap: 4px;

    li {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      color: ${palette.grey[900]};
    }
  `,
);

/** One alert per row: the badge says the state, the sentence beside it says why. */
export const AlertList = styled.div`
  display: grid;
  row-gap: 12px;
`;

export const AlertRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;
